import { render, staticRenderFns } from "./learn.vue?vue&type=template&id=1c39032a&scoped=true"
import script from "./learn.vue?vue&type=script&lang=js"
export * from "./learn.vue?vue&type=script&lang=js"
import style0 from "./learn.vue?vue&type=style&index=0&id=1c39032a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c39032a",
  null
  
)

export default component.exports